// extracted by mini-css-extract-plugin
module.exports = {"padded":"e75f10e9b4381a05339e4f5cd08a98d1-less"};